module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/picture_4-a89e0b6e8627628e901f867d0c6c22b6.webp";